export default __webpack_public_path__ + "static/media/BS.997103bc.svg";